import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import classNames from 'classnames'
import styles from './RegistrationStepper.module.scss'
import CheckMarkIcon from '../CheckMarkIcon/CheckMarkIcon'

import KP5CONSTANTS from '../../utils/constants'
import { useTranslation } from 'react-i18next'

const RegistrationStepper = (props) => {
  const { isInvited, isSubAdminPath, productParam, className } = props
  let { registrationReason = '', currentStep } = props

  const { t } = useTranslation('common')
  const isHiddenRegistrationPath =
    isInvited ||
    isSubAdminPath ||
    KP5CONSTANTS.REGISTER_PRODUCTS_WITH_HIDDEN_PATHS.HIDDEN.includes(productParam)

  const steps = [
    { label: t('Work email'), completed: false },
    { label: t('Samsung Account'), completed: false },
    { label: t('Company Info'), completed: false },
    { label: t('Agreement'), completed: false }
  ]

  const addProductSelectionStep =
    registrationReason &&
    !(registrationReason === KP5CONSTANTS.REGISTRATION_REASONS.SUB_ADMIN_REGISTRATION)

  if (addProductSelectionStep) {
    /**
     * Added as an add-on via KP5-3257
     * This new step isn't currently handled by KP5 , but rendered in here to have consistency with the UI from SamsungKnox Portal
     */
    // currentStep = currentStep > 1 ? currentStep + 1 : currentStep
    // Add product selection step after work email
    steps.splice(1, 0, { label: t('Product selection'), completed: false })
  } else {
    currentStep = isHiddenRegistrationPath ? 0 : currentStep - 1 // For MSP/KDP and sub-admin registration, work email should still be displayed so it should start with 0
  }

  // Mark steps as completed
  for (let i = 0; i < currentStep; i++) {
    steps[i].completed = true
  }

  return (
    <Container fluid className={classNames(styles.container, className)}>
      <Row className={styles.row}>
        {steps.map((step, index) => {
          const isCurrentStep = currentStep === index
          return (
            <Col key={step.label} className={styles.stepContainer}>
              <div className={styles.stepContent}>
                <div
                  className={classNames(
                    styles.circle,
                    isCurrentStep ? styles.current : '',
                    step.completed ? styles.completed : ''
                  )}
                >
                  {step.completed ? (
                    <CheckMarkIcon className={styles.checkIcon} />
                  ) : (
                    <span
                      className={classNames(
                        styles.circleText,
                        isCurrentStep ? styles.textCurrent : styles.textDefault
                      )}
                    >
                      {index + 1}
                    </span>
                  )}
                </div>
                <div
                  className={classNames(
                    styles.stepLabel,
                    isCurrentStep ? styles.labelCurrent : '',
                    step.completed ? styles.labelCompleted : '',
                    !isCurrentStep && !step.completed ? styles.labelDefault : ''
                  )}
                >
                  {step.label}
                </div>
              </div>
              {index !== steps.length - 1 && <div className={styles.connector} />}
            </Col>
          )
        })}
      </Row>
    </Container>
  )
}

RegistrationStepper.displayName = 'RegistrationStepper'

export default RegistrationStepper
